import './BlockLoader.styles.scss';

import { ProgressSpinner } from 'primereact/progressspinner';
import { FC } from 'react';

import { BlockLoaderProps } from './BlockLoader.types';

const BlockLoader: FC<BlockLoaderProps> = ({ isLoading }) => {
  return (
    isLoading && (
      <div className="BlockLoader-Component">
        <ProgressSpinner />
      </div>
    )
  );
};

export default BlockLoader;
